import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { Environment } from '../environment/environment';
var HttpFactory = /** @class */ (function () {
    function HttpFactory() {
    }
    HttpFactory.createTranslateHttpLoader = function (http) {
        var environmentConfig = Environment.environmentConfig();
        return new TranslateHttpLoader(http, environmentConfig.translateURL, environmentConfig.translateSuffix);
    };
    return HttpFactory;
}());
export { HttpFactory };
